import { Dropdown } from 'react-bootstrap';
import React from 'react'

const ExtensionDropdownItem = ({ extension, onItemSelected, listOfOnlineAgents, extensionStatuses }) => {
    const dropDownItemName = `(${extension.shortNum}) ${extension.device[0] !== '0' ? '0' + extension.device : extension.device}`;
    const dropDownItemValue = extension.shortNum;

    // find the extension status based on the state
    const extensionStatus = extensionStatuses && extensionStatuses.find(status => status.extId.split('@')[0] === extension.device);
    const agent = listOfOnlineAgents && listOfOnlineAgents.find(onlineAgent => onlineAgent.device === extension.device);
    // check if the extension is in a conversation
    const disabled = extensionStatus ? extensionStatus?.inConv : false;

    return (
        <Dropdown.Item style={{'padding':'3px 10px'}} key={extension._id} disabled={disabled} onClick={() => onItemSelected(dropDownItemValue)}>
            {agent?.agentName && <span className='agentExtSpan'>({agent.agentName})</span>}
            {dropDownItemName} <i className={`fa-solid ${disabled ? 'fa-phone-slash fa-flip-horizontal' : 'fa-phone'}`}></i>
        </Dropdown.Item>
    );
};
export default ExtensionDropdownItem